import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cutom-loader',
  templateUrl: './cutom-loader.component.html',
  styleUrls: ['./cutom-loader.component.scss']
})
export class CutomLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
